import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { TokenInterceptorFn, TovsModaCoreRoutes } from '@totvsmoda/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppRoutes } from './app/app.routes';
import { importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(TovsModaCoreRoutes),
        provideRouter(AppRoutes),
        provideHttpClient(withInterceptors([TokenInterceptorFn])),
        importProvidersFrom([BrowserAnimationsModule]),
    ],
})
    .catch(e => console.error(e));
